import 'typeface-roboto';

import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  palette: {
    primary: {
      main: '#8c6a59',
      contrastText: '#fff',
    },
    secondary: {
      main: '#c5b19a',
    },
  },
  shape: {
    borderRadius: 0,
  },
});

// Primary
// bf9278
// P — Light
// #f3c2a7
// P — Dark
// #8d644c
// Secondary
// #d7ccc8
// S — Light
// #fffffb
// S — Dark
// #a69b97
